let Test = require('@/mixins/Forms/2022/NRCA_LTI_04_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            functional_test: {
                name: `B. Functional Testing Method 1: Illuminance Measurement (NA7.6.3.2)`,
                steps: {
                    step_1: {                        
                        id: `1`,
                        name: `At circuit panel, select the circuit that serves the disaggregated lighting load of the entire facility and serves spaces required to meet §110.12.`,
                        code_reference:`NA7.6.3.2.3, Method 3(a)`,
                    },
                    step_2: {
                        id: `2`,
                        name: `<b>Full output test</b>`,
                        code_reference: `NA7.6.3.2.3, Method 3(b)`,
                        rows: {
                            row_1: {
                                id: `2.1`,
                                type: 'Text',
                                text: `Using the facility lighting controls, set the lighting system to full output. The lighting in areas with photo controls or occupant/vacancy sensors may be at less than full output or may be off.`,
                                code_reference:`NA7.6.3.2.3, Method 3(b)1`
                            },
                            row_2: {
                                id: `2.2`,
                                type: 'Float',
                                question: `Measure the current at the lighting circuit and enter the value in amperes (A).`,
                                code_reference:`NA7.6.3.2.3, Method 3(b)2`,
                                answer: '',
                                circuits: [],
                                // merge_cells: true,
                            },
                            row_3: {
                                id: `2.3`,
                                type: 'Text',
                                text: `Simulate a demand response condition using the demand responsive control.`,
                                code_reference:`NA7.6.3.2.3, Method 3(b)3`
                            },
                            row_4: {
                                id: `2.4`,
                                type: 'Float',
                                question: `Measure the current at the lighting circuit with the electric lighting system in the demand response condition and enter the value in amperes (A).`,
                                code_reference:`NA7.6.3.2.3, Method 3(b)4`,
                                answer: '',
                                circuits: [],
                                // merge_cells: true,
                            },
                            row_5: {
                                id: `2.5`,
                                type: 'Percentage',
                                question: `Calculate the percent reduction in current from the full output condition to the demand response condition and enter the value in %. (Percent reduction = [(Line b - Line d) / Line b] * 100%).`,
                                code_reference:`NA7.6.3.2.3, Method 3(b)5, Method 3(b)6`,
                                answer: '',
                                circuits: [],
                                // merge_cells: true,
                            },
                            row_6: {
                                id: `2.6`,
                                type: 'BooleanResult',
                                question: `The percent reduction in current (Line e) is at least 15%. (Line e ≥ 15%)`,
                                code_reference:`NA7.6.3.2.3, Method 3(b)6`,
                                answer: false,
                                circuits: [],
                                // merge_cells: true,
                            },
                        }
                    },
                    step_3:{
                        id: `3`,
                        name:`<b>Minimum output test</b>`,
                        code_reference: ``,
                        rows:{
                            row_1:{
                                id: `3.1`,
                                type:'Text',
                                text:`Using the facility controls, set the lighting system to minimum output (but not off). The lighting in areas with photo controls or occupant/vacancy sensors may be at more than minimum output or may be off.`,
                                code_reference:`NA7.6.3.2.3, Method 3(c)1`
                            },
                            row_2:{
                                id: `3.2`,
                                type:'Float',
                                question:`Measure the current at the lighting circuit and enter the value in amperes (A).`,
                                code_reference:`NA7.6.3.2.3, Method 3(c)2`,
                                answer:'',
                                circuits: [],
                                // merge_cells: true,
                            },
                            row_3:{
                                id: `3.3`,
                                type:'Text',
                                text:`Simulate a demand response condition using the demand responsive control.`,
                                code_reference:`NA7.6.3.2.3, Method 3(c)3`
                            },
                            row_4:{
                                id: `3.4`,
                                type:'Float',
                                question:`Measure the current at the lighting circuit with the electric lighting system in the demand response condition and enter the value in amperes (A).`,
                                code_reference:`NA7.6.3.2.3, Method 3(c)4`,
                                answer:'',
                                circuits: [],
                                // merge_cells: true,
                            },
                            row_5:{
                                id: `3.5`,
                                type:'BooleanResult',
                                question:`The current in the demand response condition (Step 3.4) is not less than the current in the minimum output condition (Step 3.2). (Step 3.4 ≥ Step 3.2).`,
                                code_reference:` NA7.6.3.2.3, Method 3(c)5`,
                                answer:false,
                                circuits: [],
                                // merge_cells: true,
                            },
                        }
                    }
                },
                result: false,
                comments: '',
                circuits: [],
            },
        }
    },

    mounted() {
        if (this.data == null) {
            this.addCircuit();
        }
    },

    methods: {

        functionalTestEvaluation() {

            this.form.functional_test.result = true;
            // this.functional_test.steps.step_3.rows.row_5.answer = true;

            var steps = this.functional_test.steps;
            var s2Questions = steps.step_2.rows;

            // row_2_5  && row_2_6
            var row_2_5 = 0, row_2_2 = 0;
            // var row_2_6 = false;
            _.each(this.form.functional_test.circuits, (circuit, index) => {
                var row_2_2 = s2Questions.row_2.circuits[index].answer;
                var row_2_4 = s2Questions.row_4.circuits[index].answer;
                var row_2_5 = ((row_2_2 - row_2_4) / row_2_2);

                s2Questions.row_5.circuits[index].answer = (this.isValidNumber(row_2_5) && row_2_2 > 0 && row_2_4) ? row_2_5 : 0;

                // row_2_6 >= 15%
                row_2_6 = s2Questions.row_6.circuits[index].answer = (row_2_2 > 0 && row_2_4 > 0 && row_2_5 >= .15 ) ? true : false;
            });
            // var row_2_6 = s2Questions.row_6.answer = (row_2_2 > 0 && row_2_4 > 0 && row_2_5 >= .15 ) ? true : false;

            // s3Questions
            var s3Questions = steps.step_3.rows;

            var row_3_5 = false;
            _.each(this.form.functional_test.circuits, (circuit, index) => {
                var row_3_2 = s3Questions.row_2.circuits[index].answer;
                var row_3_4 = s3Questions.row_4.circuits[index].answer;

                row_3_5 =  s3Questions.row_5.circuits[index].answer = (row_3_4 > 0 && row_3_2 > 0 && row_3_4 >= row_3_2) ? true : false;

                if (row_2_6 == false || row_3_5 == false) {
                    this.form.functional_test.result = false;
                }
            });
            // var row_3_5 = s3Questions.row_5.answer = (row_3_4 > 0 && row_3_2 > 0 && row_3_4 >= row_3_2) ? true : false;

            // if (row_2_6 == false || row_3_5 == false) {
            //         this.form.functional_test.result = false;
            //     }
        },

        loadFormData() {
            if (!this.data) return;

            _.each(this.data.construction_inspection.rows, (question, i) => {
                this.form.construction_inspection.rows[i].answer = question.answer;
            })

            _.each(this.data.functional_test.circuits, circuit => {
                this.updateQuestionCircuits(circuit);
            })

            _.each(this.data.functional_test.steps, (step, i) => {
                _.each(step.rows, (row, j) => {
                    _.each(this.data.functional_test.circuits, (circuit, k) => {
                        if (!this.isText(this.form.functional_test.steps[i].rows[j])) {
                            if (row.hasOwnProperty('merge_cells')) {
                                this.form.functional_test.steps[i].rows[j].answer = row.answer;
                            } else {
                                this.form.functional_test.steps[i].rows[j].circuits[k].answer = row.circuits[k].answer
                            }
                        }
                    })
                })
            })

            this.form.comments = this.data.comments;
        },

        removeCircuit() {
            if (this.canRemoveCircuit) {
                var circuit = this.form.functional_test.circuits[this.form.functional_test.circuits.length - 1];
                Alert.confirmation(`All data with from circuit ${circuit.name} will be removed.<br>Do you want to continue?`).then(response => {
                    this.form.functional_test.circuits.pop();
                    this.removecircuitFromQuestions();
                }).catch(() => {
                })
            }
        },

        removeCircuitFromQuestions() {
            _.each(this.form.functional_test.steps, step => {
                _.each(step.rows, question => {
                    if (!this.isText(question)) {
                        question.circuit.pop()
                    }
                })
            })
        },

        addCircuit() {
            this.updateQuestionCircuits({
                id: (this.form.functional_test.circuits.length + 1),
                name: `#${this.form.functional_test.circuits.length + 1}`
            });
        },

        updateQuestionCircuits(circuit) {
            this.form.functional_test.circuits.push(circuit);
            _.each(this.form.functional_test.steps, step => {
                _.each(step.rows, question => {
                    if (question.hasOwnProperty('merge_cells')) {
                        question.answer = this.getDefaultValueForDinamicQuestion(question);
                    } else if (question.type != 'Text') {
                        question.circuits.push({
                            id: circuit.id,
                            name: circuit.name,
                            answer: this.getDefaultValueForDinamicQuestion(question),
                        });
                    }
                })
            })
        },

    },

    computed: {

        rowColspan() {
            return this.form.functional_test.circuits.length;
        },

        canRemoveCircuit() {
            return this.testIsReady ? (this.form.functional_test.circuits.length > 1) : false;
        },
    }

}
